import axios from "axios";
import { User } from "../models";
import { UserDatabaseModel, userFromDatabaseModel } from "../database-models/user";

function unwrap(response: any): User {
    if (!response.data?.success) throw new Error(response.data?.error || 'Request failed');
    return userFromDatabaseModel(response.data.result as UserDatabaseModel);
}

export function signup(name: string, email: string, password: string): Promise<User> {
    return axios.post('/1/auth/signup', { name, email, password }).then(unwrap);
}

export function login(email: string, password: string): Promise<User> {
    return axios.post('/1/auth/login', { email, password }).then(unwrap);
}

export function googleAuth(idToken: string): Promise<User> {
    return axios.post('/1/auth/google', { idToken }).then(unwrap);
}

export function fetchMe(): Promise<User> {
    return axios.get('/1/auth/me').then(unwrap);
}

export function patchMe(body: { name?: string; email?: string; current_password?: string; new_password?: string }): Promise<User> {
    return axios.patch('/1/auth/me', body).then(unwrap);
}

export function testerAuth(): Promise<User> {
    return axios.post('/1/auth/tester').then(unwrap);
}

export function logoutUser(): Promise<void> {
    return axios.post('/1/auth/logout').then(response => {
        if (!response.data?.success) throw new Error('Failed to logout.');
    });
}
